import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import WhySection from "@/components/WhySection";
import EcosystemSection from "@/components/EcosystemSection";
import SolutionsSection from "@/components/SolutionsSection";
import CommunitiesSection from "@/components/CommunitiesSection";
import CTASection from "@/components/CTASection";

export default function LandingPage() {
  const location = useLocation();
  useEffect(() => {
    document.title = "Proactive UMS Corporate | The PUMS Ecosystem";
    const target = location.state?.scrollTo;
    if (target) {
      setTimeout(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <WhySection />
      <EcosystemSection />
      <SolutionsSection />
      <CommunitiesSection />
      <CTASection />
    </>
  );
}
